import React, { useEffect, useRef, useState } from 'react';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import PayDetailsEdit from './PayDetailsEdit';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import { Button, Col, Form, Input, Popconfirm, Row } from 'antd';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import fetchApi from '../../../utils/api/fetchApi';
import systemConfig from '../../../config/systematic';

const PayDetails = (props: any) => {

    const ref = useRef<any>(undefined);
    const { data, closeModal } = props;
    const [isConfirmRefundOpen, setIsConfirmRefundOpen] = useState<boolean>(false);
    const [form] = Form.useForm();
    const notificationApi = useNotificationInstance()
    let wmService: any = systemConfig.wmService;
    const [confirmRefundData, setConfirmRefundData] = useState<any>()
    /** api服务id */
    const apiId = 'payDetails';

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            // handleChangeOne = ref.current.handleChangeOne;
        }

        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '订单id',
            dataIndex: 'cateringOrderId',
        },
        {
            title: '支付方式名称',
            dataIndex: 'paymentMethodName',
        },
        {
            title: '支付金额',
            dataIndex: 'payAmount',
        },
        {
            title: '待减发票金额',
            dataIndex: 'eductedAmount',
        },
        {
            title: '退款金额(原路)',
            dataIndex: 'refundAmount',
        },
        {
            title: '退款金额(现金)',
            dataIndex: 'cashRefundAmount',
        },
        {
            title: '退款',
            dataIndex: 'payId',
            render: (text: any, record: any) => {
                if (text) {
                    return <Popconfirm placement={"bottom"} title={<div>
                        {<div style={{ color: "red", fontSize: 20 }}>2.该订单属于线上支付，会原路返还, 确认吗？</div>}
                    </div>} onConfirm={() => openConfirmRefund(record)} okText="确定" cancelText="取消">
                        <Button danger>退款</Button>
                    </Popconfirm>

                }else{
                    return <></>
                }

            }
        },

    ];
    /**打开退款页面 */
    const openConfirmRefund = (apiData: any) => {

        setIsConfirmRefundOpen(true)
        setConfirmRefundData(apiData)

    }
    /**进行反结账操作 */
    const reverseClosing = () => {
        fetchApi.POST(wmService, {
            apiId: "payOrder",
            apiExtend: "orderBackEx",
            apiData: confirmRefundData
        }).then(async (res) => {

            if (res.success) {
                showCustomNotification(notificationApi!, {
                    type: 'success',
                    message: "退款成功",
                    description: "成功!",
                    duration: 0.5
                });
                setIsConfirmRefundOpen(false)
                // antMessage("success", '反结账成功', "成功", { duration: 0.5 });
            }

        }).catch((err) => {
            showCustomNotification(notificationApi!, {
                type: 'error',
                message: "退款失败",
                description: err.message,
                duration: 0.5
            });
            // antMessage('error', '反结账失败', err.message, { duration: 0.5 });
            console.log("err", err);

        })


    }
    /**校验退款 */
    const isConfirmRefund = () => {
        form.validateFields()
            .then(async (values: any) => {
                const { logPass, confirmLogPass } = values;
                if (logPass !== confirmLogPass) {
                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: "失败",
                        description: "密码不一致",
                        // duration:0.5
                    });
                    // antMessage('error', '失败', "密码不一致");
                    return false
                }
                fetchApi.POST(wmService, {
                    apiId: "login",
                    apiExtend: "confirmLoginPass",
                    apiData: {
                        logPass,
                        confirmLogPass,
                        mountDataOptions: {
                            userMount: {
                                isUserLogin: true
                            }
                        }
                    }
                }).then((res) => {


                    showCustomNotification(notificationApi!, {
                        type: 'success',
                        message: "成功",
                        description: "密码正确"
                    });
                    // antMessage("success", '成功', "密码正确",);
                    reverseClosing()


                }).catch((err) => {
                    // antMessage('error', '错误', err.message);
                    showCustomNotification(notificationApi!, {
                        type: 'error',
                        message: "错误",
                        description: err.message
                    });
                })

            }).catch(err => {
                showCustomNotification(notificationApi!, {
                    type: 'error',
                    message: "数据检验失败",
                    description: err.message
                });
                // antMessage('error', '数据检验失败', err.message);
            });

    }
    /**关闭退款 */
    const closeConfirmRefund = () => {
        setIsConfirmRefundOpen(false)
    }
    const handleOk = (e: any) => {
        closeModal(true);
    };

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '支付详情',
        apiId,
        columns,
        sendPageData: { id: data?.id, dataStatusType: data?.dataStatusType },
        showStates: true,
        pagination: true,
        showAdd: data?.isAdd === 1 ? false : true,
        showDelete: data?.isDelete === 1 ? false : true,
        showEdit: data?.isEdit === 1 ? false : true,
        EditComponent: PayDetailsEdit,
    };

    return (
        <>
            {data?.isModel ? <AntDraggableModal
                title={'支付详情'}
                open={true}
                okText='确定'
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={handleOk}
                closable={false}
                maskClosable={false}
                width={1000}>
                <WebUniversalNewEx props={extendProps} ref={ref}></WebUniversalNewEx>
            </AntDraggableModal> : <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>}
            {isConfirmRefundOpen ? <AntDraggableModal
                title={<div style={{ color: "red", fontSize: 20 }}>确认退款吗？一旦退款会进行线上退款，请慎重！！</div>}
                open={true}
                okText='确定'
                cancelText='取消'
                closable={false}
                maskClosable={false}
                width={"60%"}
                onCancel={closeConfirmRefund}
                onOk={isConfirmRefund}

            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={isConfirmRefund}
                >
                    <Row>

                        <Col span={24}>
                            <Form.Item
                                label="登录密码"
                                rules={[{ message: '请输入登录密码!', required: true }]}
                                name="logPass">
                                <Input placeholder='登录密码' ></Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label="确认密码"
                                rules={[{ message: '请输入确认密码!', required: true }]}
                                name="confirmLogPass">
                                <Input placeholder='确认密码' ></Input>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>

            </AntDraggableModal> : ""}
        </>
    )
}

export default PayDetails